// You can't use anything on the window object during build time - it crashes
// the build - so use these constants to determine where you are.


/**
 * The code is running because we're statically rendering the pages, i.e.
 * `gatsby build` is running
 */
export const isBuildTime = typeof window === 'undefined';

/**
 * The code is running in a browser, either in dev or in built mode.
 */
export const isInBrowser = !isBuildTime;
/**
 * The code is running in local dev mode, i.e. `gatsby develop`
 */
export const isDevTime   = process.env.NODE_ENV === 'development';
/**
 * The code is not running in `gatsby build` or `gatsby develop`; i.e., it is
 * built, served by an Nginx server, and runs in a user's browser.
 */
export const isInProduction = !isBuildTime && !isDevTime;
